import React from 'react';
import { styled } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { issueTotalCount_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/issueTotalCount_softwareReleasesVersionDetailIssueList.graphql';

interface Props {
	jiraVersion: issueTotalCount_softwareReleasesVersionDetailIssueList$key;
}

export const IssueTotalCount = ({ jiraVersion }: Props) => {
	const data = useFragment(
		graphql`
			fragment issueTotalCount_softwareReleasesVersionDetailIssueList on JiraVersion {
				allIssuesRedesignTemp: issues @required(action: THROW) {
					totalCount @required(action: THROW)
				}
			}
		`,
		jiraVersion,
	);

	return <TotalCountLozenge>{data.allIssuesRedesignTemp.totalCount}</TotalCountLozenge>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TotalCountLozenge = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.accent.gray.subtlest'),

	font: token('font.body.small'),
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize}px`,
	// This margin is to align vertically, due to font style, 2 pixels are misaligned that looks not right.
	marginTop: token('space.025'),
	paddingRight: token('space.050'),
	paddingLeft: token('space.050'),
});
